// removed by extract-text-webpack-plugin
module.exports = {"heading":"ForgotPassword-hashed__heading__-iqde","button":"ForgotPassword-hashed__button__3dXh0","actionsWrapper":"ForgotPassword-hashed__actionsWrapper__15TF7","inputGroup":"ForgotPassword-hashed__inputGroup__2r09h","input":"ForgotPassword-hashed__input__x0afE","error":"ForgotPassword-hashed__error__Tpunn","hasError":"ForgotPassword-hashed__hasError__2wuXC","infoMessage":"ForgotPassword-hashed__infoMessage__3Ya4v"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-angular/components/ForgotPassword/ForgotPassword-hashed.scss
// module id = 1153
// module chunks = 0